import _ from 'lodash';
import moment from 'moment';
export default class CalendarizacaoController {
    constructor($rootScope, $state, $window, $filter, $timeout, UIService, AuthenticationService, Pedidoinspeccao, Group, Agendamento, Avatar) {
        this.$rootScope = $rootScope;
        this.$state = $state;
        this.$window = $window;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.UI = UIService;
        this.user = AuthenticationService.getUser();
        this.Pedidoinspeccao = Pedidoinspeccao;
        this.Group = Group;
        this.Agendamento = Agendamento;
        this.Avatar = Avatar;
        this.selectedTab = 0; // 0 by default
        this.calendarAgendamentosLoading = true;
        this.calendarAgendamentosOptions = {
            eventClick: (event, jsEvent) => {
                let ag = this.agendamentos.find(x => x.id === event.id);
                if (ag) {
                    let url = $state.href('app.pedidos.details', { id: ag.pedidoId }, { absolute: true });
                    this.$window.open(url, '_blank');
                    if (jsEvent)
                        jsEvent.preventDefault();
                    return false;
                }
            },
            defaultView: 'agendaDay',
            locale: 'pt',
            themeSystem: 'bootstrap4',
            header: {
                left: 'prev,next today',
                center: 'title',
                right: 'month,agendaWeek,agendaDay,listMonth'
            },
            navLinks: true,
            defaultTimedEventDuration: '01:00:00',
            allDaySlot: false,
            displayEventEnd: false,
            timeFormat: "HH:mm",
            minTime: "08:00:00",
            maxTime: "22:00:00",
            height: 'auto',
            slotDuration: "00:30:00",
            slotLabelFormat: "HH:mm",
            views: {
                agendaWeek: {
                    columnHeaderFormat: "DD/MM"
                }
            },
            firstDay: 1,
            nowIndicator: true,
            weekends: false,
            weekNumberTitle: 'Sem.',
            eventLimitText: 'agd.',
            noEventsMessage: 'Sem agendamentos a apresentar.',
            weekNumbers: true,
            eventLimit: true,
            buttonText: {
                today: 'Hoje',
                month: 'Mensal',
                week: 'Semanal',
                day: 'Diário',
                list: 'Lista'
            }
        };
        this.agendamentos = [];
        this.calendarAgendamentosEvents = [];
        // Tecnico view
        this.auxTecnico = {
            selected: undefined
        };
        this.calendarTecnicoLoading = true;
        this.calendarTecnicoOptions = {
            eventClick: (event, jsEvent) => {
                let ag = this.agendamentosTecnico.find(x => x.id === event.id);
                if (ag) {
                    let url = $state.href('app.pedidos.details', { id: ag.pedidoId }, { absolute: true });
                    this.$window.open(url, '_blank');
                    if (jsEvent)
                        jsEvent.preventDefault();
                    return false;
                }
            },
            customButtons: {
                filter: {
                    text: 'Filtrar',
                    click: () => {
                        this.getAgendamentosTecnico();
                    }
                },
                clear: {
                    text: 'LIMPAR',
                    click: () => {
                        this.cleanAgendamentosTecnico();
                    }
                }
            },
            defaultView: 'agendaWeek',
            locale: 'pt',
            themeSystem: 'bootstrap4',
            header: {
                left: 'prev,next today filter clear',
                center: 'title',
                right: 'month,agendaWeek,agendaDay,listMonth'
            },
            navLinks: true,
            defaultTimedEventDuration: '01:00:00',
            allDaySlot: false,
            displayEventEnd: false,
            timeFormat: "HH:mm",
            minTime: "08:00:00",
            maxTime: "22:00:00",
            height: 'auto',
            slotDuration: "00:30:00",
            slotLabelFormat: "HH:mm",
            views: {
                agendaWeek: {
                    columnHeaderFormat: "DD/MM"
                }
            },
            firstDay: 1,
            nowIndicator: true,
            weekends: false,
            weekNumberTitle: 'Sem.',
            eventLimitText: 'prcs.',
            noEventsMessage: 'Sem processos a apresentar.',
            weekNumbers: true,
            eventLimit: true,
            buttonText: {
                today: 'Hoje',
                month: 'Mensal',
                week: 'Semanal',
                day: 'Diário',
                list: 'Lista'
            }
        };
        this.agendamentosTecnico = [];
        this.calendarTecnicoEvents = [];
        this.calendarTecnicoLoading = false;
        this.tecnicosLoading = true;
        this.getTecnicos();
        this.getAgendamentosTecnico(); // Loading by default (empty)
    }
    ;
    getTecnicos = () => {
        this.Group.findOne({
            filter: {
                where: {
                    name: {
                        like: "Inspetor%IE",
                    },
                },
                include: {
                    relation: "usergroup",
                    scope: {
                        include: "user",
                    },
                },
            },
        }).$promise.then((g) => {
            this.tecnicos = [];
            if (g.usergroup) {
                g.usergroup.forEach((u) => {
                    this.tecnicos.push(u.user);
                });
                this.tecnicos.sort((a, b) => a.name.localeCompare(b.name));
            }
            this.tecnicosLoading = false;
        }).catch((error) => {
            console.log(error);
            this.UI.addToast("Erro no carregamento de técnicos. Verifique a ligação");
            this.tecnicosLoading = false;
        });
    };
    switchTab = (tab) => {
        if (this.selectedTab === tab)
            return;
        this.selectedTab = tab;
        if (tab === 0) {
            this.getAgendamentosTecnico();
        }
        else if (tab === 1) {
            this.getAgendamentos();
        }
    };
    cleanAgendamentosTecnico = () => {
        this.calendarTecnicoLoading = true;
        this.$timeout(() => {
            this.auxTecnico = { selected: undefined };
            this.agendamentosTecnico = [];
            this.calendarTecnicoEvents = [];
            this.calendarTecnicoLoading = false;
        }, 10);
    };
    getAgendamentos = () => {
        this.calendarAgendamentosLoading = true;
        this.Agendamento.find({
            filter: {
                where: {
                    active: 1,
                },
                include: ['Funcionario', {
                        relation: 'Pedidoinspeccao',
                        scope: {
                            where: {
                                estadoId: 4 // Only show "Agendados" agendamentos
                            },
                            include: ['Estado', 'Requisitante', {
                                    relation: 'Dadosinstalacao', scope: { include: ['Tipoimovel', 'Fraccao'] }
                                }]
                        }
                    }]
            }
        }).$promise.then((res) => {
            // Redundant because of query, but ignore agendamentos "In Agendamento" (We need to not consider Agendamentos without Pedidoinspeccao with estado 4).
            this.agendamentos = _.filter(res, (r) => (r.hora != null) && (r.Pedidoinspeccao != null) && (r.Pedidoinspeccao.Estado.designacao === "Agendado") && (r.Pedidoinspeccao.Estado.active === 1));
            this.calendarAgendamentosEvents = [];
            for (let i = 0; i < this.agendamentos.length; i++) {
                let agDate = moment(this.agendamentos[i].data).startOf('day');
                let aux = moment(this.agendamentos[i].hora, 'HH:mm:ss');
                agDate.set({ hour: aux.get('hour'), minute: aux.get('minute'), second: aux.get('second') });
                // let composedAddress = this.agendamentos[i].Pedidoinspeccao.Dadosinstalacao.morada + "\n" +
                let composedAddress = this.agendamentos[i].Funcionario.name + "\n" +
                    this.agendamentos[i].Pedidoinspeccao.Dadosinstalacao.codigoPostal1 + "-" +
                    this.agendamentos[i].Pedidoinspeccao.Dadosinstalacao.codigoPostal2 + " " +
                    this.agendamentos[i].Pedidoinspeccao.Dadosinstalacao.codigoPostal3;
                this.calendarAgendamentosEvents.push({
                    id: this.agendamentos[i].id,
                    title: composedAddress,
                    start: agDate,
                    color: this.Avatar.getColor(this.Avatar.getInitials(this.agendamentos[i].Funcionario.name))
                });
            }
            this.calendarAgendamentosLoading = false;
        }).catch(error => {
            console.log(error);
            this.UI.addToast("Erro na procura de agendamentos. Verifique a ligação");
            this.agendamentos = [];
            this.calendarAgendamentosEvents = [];
            this.calendarAgendamentosLoading = false;
        });
    };
    getAgendamentosTecnico = () => {
        this.calendarTecnicoLoading = true;
        if (!this.auxTecnico || !this.auxTecnico.selected) {
            this.$timeout(() => {
                this.agendamentosTecnico = [];
                this.calendarTecnicoEvents = [];
                this.calendarTecnicoLoading = false;
            }, 250); // So the fullcalendar renders properly
            return;
        }
        this.Agendamento.find({
            filter: {
                where: {
                    and: [{ active: 1 }, { tecnicoId: this.auxTecnico.selected.id }]
                },
                include: ['Funcionario', {
                        relation: 'Pedidoinspeccao',
                        scope: {
                            include: ['Estado', 'Requisitante', {
                                    relation: 'Dadosinstalacao', scope: { include: ['Tipoimovel', 'Fraccao'] }
                                }]
                        }
                    }],
                order: 'id DESC',
                limit: 1000
            }
        }).$promise.then((res) => {
            this.agendamentosTecnico = res;
            this.calendarTecnicoEvents = [];
            for (let i = 0; i < this.agendamentosTecnico.length; i++) {
                let agDate = moment(this.agendamentosTecnico[i].data).startOf('day');
                let aux = moment(this.agendamentosTecnico[i].hora, 'HH:mm:ss');
                agDate.set({ hour: aux.get('hour'), minute: aux.get('minute'), second: aux.get('second') });
                // let composedAddress = this.agendamentos[i].Pedidoinspeccao.Dadosinstalacao.morada + "\n" +
                let composedAddress = "Processo nº " + this.agendamentosTecnico[i].Pedidoinspeccao.id + "\n" +
                    this.agendamentosTecnico[i].Pedidoinspeccao.Dadosinstalacao.codigoPostal1 + "-" +
                    this.agendamentosTecnico[i].Pedidoinspeccao.Dadosinstalacao.codigoPostal2 + " " +
                    this.agendamentosTecnico[i].Pedidoinspeccao.Dadosinstalacao.codigoPostal3;
                this.calendarTecnicoEvents.push({
                    id: this.agendamentosTecnico[i].id,
                    title: composedAddress,
                    start: agDate,
                    color: this.agendamentosTecnico[i].Pedidoinspeccao.estadoId === 4 ? '#E57368' : '#33B679' // this.Avatar.getColor(this.Avatar.getInitials(event.Funcionario.name))
                });
            }
            this.calendarTecnicoLoading = false;
        }).catch(error => {
            console.log(error);
            this.UI.addToast("Erro na procura de processos. Verifique a ligação");
            this.agendamentosTecnico = [];
            this.calendarTecnicoEvents = [];
            this.calendarTecnicoLoading = false;
        });
    };
}
CalendarizacaoController.$inject = ['$rootScope', '$state', '$window', '$filter', '$timeout', 'UIService', 'AuthenticationService', 'Pedidoinspeccao', 'Group', 'Agendamento', 'Avatar'];
